import { request, requestForm } from '../../Common/api/client';

export function getTerminalPharmacyImportCapability() {
  return request({ method: 'GET', url: '/api/admin/terminal-pharmacy-import/capability' });
}

export function getTerminalPharmacyImportHistory(params = {}) {
  return request({ method: 'GET', url: '/api/admin/terminal-pharmacy-import', params });
}

export function getTerminalPharmacyImportDetail(params = {}) {
  return request({ method: 'GET', url: '/api/admin/terminal-pharmacy-import/detail', params });
}

export function previewTerminalPharmacyImport({ cpId, file, otpToken }) {
  const form = new FormData();
  form.append('cpId', String(cpId));
  form.append('file', file);
  return requestForm({
    method: 'POST',
    url: '/api/admin/terminal-pharmacy-import/preview',
    data: form,
    headers: otpToken ? { 'X-OTP-Token': otpToken } : {},
  });
}

export function applyTerminalPharmacyImport({ batchId, otpToken }) {
  return request({
    method: 'POST',
    url: '/api/admin/terminal-pharmacy-import/apply',
    data: { batchId },
    headers: otpToken ? { 'X-OTP-Token': otpToken } : {},
  });
}
